import { getMixpanel } from '@client/tracking/mixpanel';
import { EventNames, FEATURE_OVERVIEW, TrackingPageName } from '@client/tracking/mixpanel-constants';

export const sendViewedCancellationDetailsPage = () => {
  getMixpanel().track(EventNames.VIEWED_PAGE, {
    Feature: FEATURE_OVERVIEW,
    Page: TrackingPageName.CANCELLATION_DETAILS,
  });
};
